import Section from '../../Common/Section/Section'
import './TestimonialsSection.css'
import { testimonialsData } from '../../../data/TestimonialsData'
import TestimonialDisplay from '../../Common/Testimonal/TestimonialCard'
import Testimonial from '../../../models/Testimonial'
import { useState } from 'react'
import { faAngleLeft, faAngleRight, faCircle as solidCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircle as emptyCircle } from '@fortawesome/free-regular-svg-icons'

function TestimonialsSection() {

    const handlePrevious = () => {
        setCurrentTestimonial(testimonialsData.find(testimonial => testimonial.key === currentTestimonial.key - 1) || currentTestimonial )
    }

    const handleNext = () => {
        setCurrentTestimonial(testimonialsData.find(testimonial => testimonial.key === currentTestimonial.key + 1) || currentTestimonial )
    }

    const [currentTestimonial, setCurrentTestimonial] = useState<Testimonial>(testimonialsData[0])

    return (
        <Section id={"testimonials-section"} 
            sectionTitle='Testimonials' 
            titleColor='#8F0520'
            sectionSubtitle='Why others have worked with me'>
                <TestimonialDisplay testimonial={currentTestimonial} key={currentTestimonial?.key} />
                <div className='testimonial-nav'>
                    <FontAwesomeIcon icon={faAngleLeft}  className='testmonial-arrow fa-2xl' onClick={handlePrevious} />
                    {[...Array(testimonialsData.length)].map((_, index) => (
                        <FontAwesomeIcon icon={index === currentTestimonial.key ? solidCircle : emptyCircle} size='xs' className='fa-solid' key={index}/>
                    ))}
                    <FontAwesomeIcon icon={faAngleRight} className='testmonial-arrow fa-2xl' onClick={handleNext} />
                </div>
        </Section>
    )
}

export default TestimonialsSection